import Button from 'react-bootstrap/Button';
import React, { useState } from 'react';
import { useEffect } from 'react';
import Select from 'react-select';
import { setHTMLMessage, clearMessage, setMessage } from '../tools/errorhandling';
import { saveFile } from '../tools/filehandler';
import * as connector from "../dbconnector/connector";
import reports from "./reports.json";
import HotelSelection from '../customNodes/HotelSelection';
import { RxOpenInNewWindow } from "react-icons/rx";
import { GrPrint } from "react-icons/gr";
import { CiSaveUp2 } from "react-icons/ci";
import { v4 as uuid } from 'uuid';

const TriggersReports = (props) => {

    const t = props.translation;
    const [selectedReportKey, setSelectedReportKey] = useState('');
    const [formValues, setFormValues] = useState({});
    const [user, setUser] = useState({});
    const [employee, setEmployee] = useState(null);
    const [employeename, setEmployeeName] = useState(null);
    const [optionArray, setoptionArray] = useState([]);
    const [selectedhotel, setSelectedhotel] = useState("");
    const [selectedhotelname, setSelectedhotelname] = useState(null);
    const [getactiveHotels, setGetactiveHotels] = useState(true);
    const [getactiveEmployee, setGetactiveEmployees] = useState(true);
    const [selectedCleaner, setselectedCleaner] = useState(null);
    const [linkedcleaners, setlinkedcleaners] = useState({});
        const [employers, setEmployers] = useState({});
            const [employersArray, setemployersArray] = useState([]);
    const selectedReport = reports.find(r => r.key === selectedReportKey);
    const [mandaterrors, setMandaterrors] = useState([]);
    const [repporthtml, setRepporthtml] = useState([]);
    const [startDate, SetStartDate] = useState(null);
    const [endDate, SetEndDate] = useState(null);



    useEffect(() => {
        //cleandata()
        GetHotelCleaners(null, true)
        LoadEmployers()
        getMyData()
    }, []);

   const LoadEmployers = () => {
        try {

            // const select = document.getElementById("employers")
            // select.innerHTML = ""
            connector.getemployers(true).then((res) => {
                if (res.status === 200) {
                       
                    res.items.forEach((item, index) => {
 console.log(item);
                    setEmployers(prevState => { return { ...prevState, [item.id]: { item } } })
                        // const option = document.createElement("option");
                        // option.value = item.id;
                        // option.innerText = item.Naam
                        // select.appendChild(option)
                    })
                } else {
                    //setErrorMessage(res.status + ": " + res.message)
                }
            })
        } catch (error) {
            //setErrorMessage(t("error_canotgetuserlist"))
        }
    }
    const handleReportChange = (e) => {
        document.getElementById("reportviewercontent").innerHTML = ""
        document.getElementById("reportviewer").style.visibility = "hidden"
        cleandata()
        clearerrors()
        GetHotelCleaners(null, true)
        setSelectedhotel(-1)
        setSelectedhotelname(null)

        const key = e.target.value;
        setSelectedReportKey(key);
        const report = reports.find(r => r.key === key);
        if (report) {
            const initialValues = {};
            report.params.forEach(p => {
                if (p.permanent !== null && p.permanent !== undefined) {
                    initialValues[p.name] = p.permanent;
                } else if (p.default !== undefined) {
                    initialValues[p.name] = p.default;
                } else {
                    initialValues[p.name] = '';
                }
            });
            setFormValues(initialValues);
        } else {
            setFormValues({});
        }
    };
    const getMyData = async () => {
        connector.myData().then(res => {
            if (res) {
                setUser({ ...res })
            }
        })
    }

    const handleParamChange = (name, value, e) => {
        //console.log("e =", e)
        let addtoform = true;
        if (name === "nr_wkn") {
            if (value === undefined) {
                let addtoform = false;
                setFormValues(prev => ({ ...prev, [name]: "" }));
                setEmployeeName(null)
                setEmployee(null)
            } else {
                setEmployee(value)
                setEmployeeName(e.label)
            }
        }
        if (name === "hotel_id") {
            if (value === -1) {
                let addtoform = false;
                setFormValues(prev => ({ ...prev, [name]: "" }));
                setSelectedhotel("")
            }
        }
        if (name === "startDate") {
            SetStartDate(value)
        }
        if (name === "endDate") {
            SetEndDate(value)
        }
        if (addtoform)
            setFormValues(prev => ({ ...prev, [name]: value }));
        //console.log(formValues)
    };

    const getHotelEmployees = (e) => {
        document.getElementById("reportviewercontent").innerHTML = ""
        document.getElementById("reportviewer").style.visibility = "hidden"
        if (e.target.value > 0) {
            setSelectedhotel(e.target.value)
            var index = e.nativeEvent.target.selectedIndex;
            setSelectedhotelname(e.nativeEvent.target[index].text)
            handleParamChange("hotel_id", e.target.value)
        }
        else {

            setSelectedhotel("")
            setSelectedhotelname(null)
            handleParamChange("hotel_id", "")
        }

        GetHotelCleaners(e.target.value, getactiveEmployee)
    }
    const GetHotelCleaners = async (HotelId, active) => {
        setoptionArray([])
        setselectedCleaner(null)
        setlinkedcleaners([])
        if (HotelId !== null & HotelId !== "-1") {
            const res = await connector.gethotelcleaners(HotelId, active);
            const data = await res.json();

            for (const cleaner of data.items) {
                //console.log("cleaner = " , data.items)
                setlinkedcleaners(prevState => { return { ...prevState, [cleaner.id]: { cleaner } } })
            }
        } else {
            const Employees = connector.getemployees(active);
            Employees.then((list) => {
                if (list.status === 200) {
                    for (const cleaner of list.items) {
                        //console.log("cleaner" , list.items)
                        setlinkedcleaners(prevState => { return { ...prevState, [cleaner.id]: { cleaner } } })
                    }

                }
            })
        }
    }
    useEffect(() => {
        //////console.log(linkedcleaners)
        if (Object.keys(linkedcleaners).length > 0) {
            const options = Object.keys(linkedcleaners).map((key) => {
                const emp = linkedcleaners[key].cleaner;
                if (emp.nr_wkn)
                    return { value: key, label: `${emp.nr_wkn} - ${emp.achternaam}, ${emp.voornaam} ` };
                else
                    return { value: key, label: `${emp.achternaam}, ${emp.voornaam} ` };
            })
            options.unshift({ value: "", label: t('Pick an employee') })
            ////console.log(options)
            setoptionArray(options)
        }
    }, [linkedcleaners]);

    useEffect(() => {
        //////console.log(linkedcleaners)
        if (Object.keys(employers).length > 0) {
            const options = Object.keys(employers).map((key) => {
                //console.log(employers[key].item)
                const emp = employers[key].item;
                // if (emp.nr_wkn)
                //     return { value: key, label: `${emp.nr_wkn} - ${emp.achternaam}, ${emp.voornaam} ` };
                // else
                     return { value: key, label: `${emp.Naam}` };
            })
            options.unshift({ value: "", label: t('Kies een werkgever') })
            ////console.log(options)
            setemployersArray(options)
        }
    }, [employers]);

    function setcontrol(param) {
//console.log(param)
         if (param.type === "employer") {
            return <div className="report-form" key={param.name}>
                <label className='report-label' htmlFor={`param-${param.name}`}>{t(param.label)}</label>
                <Select
                    id={`param-${param.name}`}
                    onChange={e => handleParamChange(param.name, e.value, e)}
                    options={employersArray}
                    value={employersArray.find(opt => opt.value === formValues[param.name]) || null}
                    placeholder={t('Kies een werknemer')}
                    isSearchable
                    className="report-control"
                />
                <label id={`mandatparam-${param.name}`} className='report-mandat'>{param.mandatory === true ? "*" : ""}</label>
            </div>;
        }else 
        if (param.type === "employee") {
            return <div className="report-form" key={param.name}>
                <label className='report-label' htmlFor={`param-${param.name}`}>{t(param.label)}</label>
                <Select
                    id={`param-${param.name}`}
                    onChange={e => handleParamChange(param.name, e.value, e)}
                    options={optionArray}
                    value={optionArray.find(opt => opt.value === formValues[param.name]) || null}
                    placeholder={t('Kies een medewerker')}
                    isSearchable
                    className="report-control"
                />
                <label id={`mandatparam-${param.name}`} className='report-mandat'>{param.mandatory === true ? "*" : ""}</label>
            </div>;
        } else
            if (param.type === "hotels") {
                return <div className="report-form" key={param.name}>
                    <label className='report-label' htmlFor={`param-${param.name}`}>{t(param.label)}</label>
                    <HotelSelection
                        id={`param-${param.name}`}
                        isDisabled={false}
                        active={getactiveHotels}
                        data={{ disabled: false, fieldname: "nr_afd", selectedhotel: selectedhotel, handleitemchange: getHotelEmployees }} valueneeded="hotel_id" css='report-control'
                    />
                    <label id={`mandatparam-${param.name}`} className='report-mandat'>{param.mandatory === true ? "*" : ""}</label>
                </div>;
            } else {
                return <div className="report-form" key={param.name}>
                    <label className='report-label' htmlFor={`param-${param.name}`}>{t(param.label)}</label>
                    <input
                        id={`param-${param.name}`}
                        type={param.type}
                        className="report-control"
                        value={formValues[param.name] || ''}
                        onChange={e => handleParamChange(param.name, e.target.value, param.dependency)}
                        disabled={param.permanent !== null && param.permanent !== undefined}
                    />
                    <label id={`mandatparam-${param.name}`} className='report-mandat'>{param.mandatory === true ? "*" : ""}</label>
                </div>
            }
    }
    const clearerrors = () => {
        mandaterrors.map(param => {
            if (document.getElementById("mandatparam-" + param.name) !== null) {
                document.getElementById("mandatparam-" + param.name).className = "report-mandat"
                document.getElementById("mandatparam-" + param.name).innerText = "*"
            }
        }
        )
        setMandaterrors([])
    }
    const clearreport = (reportkey) => {
        document.getElementById("reportviewer").style.visibility = "hidden"
        document.getElementById("reportviewercontent").innerHTML = ""
        setMandaterrors([])
        GetHotelCleaners(null, true)
        setSelectedhotel(-1)
        setSelectedhotelname(null)
        const key = reportkey;
        setSelectedReportKey(key);
        const report = reports.find(r => r.key === key);
        if (report) {
            const initialValues = {};
            report.params.forEach(p => {

                if (p.mandatory === true) {
                    document.getElementById("mandatparam-" + p.name).innerText = "*"
                    document.getElementById("mandatparam-" + p.name).className = "report-mandat"
                }
                if (p.permanent !== null && p.permanent !== undefined) {
                    initialValues[p.name] = p.permanent;
                } else if (p.default !== undefined) {
                    initialValues[p.name] = p.default;
                } else {
                    initialValues[p.name] = '';
                }
            });
            setFormValues(initialValues);
        } else {
            setFormValues({});
        }
    }
    const printreport = () => {
        var myWindow = window.open("", '_new', "width=1500,height=768");
        myWindow.document.body.innerHTML = repporthtml;
        myWindow.document.close();
        myWindow.focus();
        myWindow.print();
        myWindow.close();
    }
    const openinwindow = () => {
        const unique_id = uuid();
        var myWindow = window.open("", unique_id, "width=1500,height=768");
        myWindow.document.body.innerHTML = repporthtml;
        myWindow.focus();

    }
    const cleandata = () => {
        SetStartDate(null)
        setEmployee(null)
        setEmployeeName(null)
        SetEndDate(null)
        setSelectedhotelname(null)
        setSelectedhotel(-1)
    }
    const savereport = () => {
        //const unique_id = uuid();
        let filename = selectedReportKey + "_[ alle hotels ].html";
        if (selectedhotelname !== null) {
            filename = selectedReportKey + " [" + selectedhotelname + "].html";
        }
        ////console.log("filename :" , filename)
        const reportToSave = new File([repporthtml], filename, { type: "text/html" });

        saveFile(reportToSave, 9, employee).then(res => {
            setMessage("Rapport bewaard in voor " + employeename + "in zijn/haar documenten tab [reports]")
        })


    }
    const triggerReportClick = () => {
        document.getElementById("reportviewer").style.visibility = "hidden"
        document.getElementById("reportviewercontent").innerHTML = ""
        clearerrors();
        if (!selectedReport) {
            setHTMLMessage("No report selected");
            return;
        }
        let mandatoryfieldsmissing = false;
        let mandatorykeymissing = {};
        const args = selectedReport.params.map(p => {
            const val = formValues[p.name];
            //console.log("name= ", p.name, " mandatory= ", p.mandatory, " val= ", val, " dependency: ", formValues[p.dependency])
            if (p.mandatory === true & (val === undefined || val.length === 0)) {
                if (p.dependency === undefined) {
                    mandatoryfieldsmissing = true;
                    mandaterrors.push(
                        {
                            dependency: p.dependency,
                            name: p.name,
                            label: p.label
                        }
                    )
                    document.getElementById("mandatparam-" + p.name).className = "report-mandat-missing"
                    document.getElementById("mandatparam-" + p.name).innerText = "*"
                    mandatorykeymissing[p.name] = p.name
                } else if (p.dependency !== undefined & formValues[p.dependency] !== undefined & p.dependency.length > 0 & formValues[p.dependency].length > 0) {
                    mandatoryfieldsmissing = false;
                    document.getElementById("mandatparam-" + p.name).className = "report-mandat"
                    document.getElementById("mandatparam-" + p.name).innerText = ""
                } else {
                    document.getElementById("mandatparam-" + p.name).className = "report-mandat-missing"
                    document.getElementById("mandatparam-" + p.name).innerText = "*"
                    mandatoryfieldsmissing = true;
                    mandaterrors.push(
                        {
                            dependency: p.dependency,
                            name: p.name,
                            label: p.label
                        }
                    )
                    mandatorykeymissing[p.name] = p.name
                }

            } else if (p.mandatory === true & (val !== undefined || val.length > 0)) {
                document.getElementById("mandatparam-" + p.name).className = "report-mandat"
                document.getElementById("mandatparam-" + p.name).innerText = ""
            }
            return (p.permanent !== null && p.permanent !== undefined) ? p.permanent : (val !== undefined ? val : p.default);
        });
        if (mandatoryfieldsmissing === false) {
            const func = connector[selectedReport.connector];
            const myName = user.achternaam + ", " + user.voornaam
            if (typeof func === 'function') {
                func(...args, myName).then(response => {
                    if (response !== undefined) {
                        if (response.status === 210) {
                            response.json().then(body => {
                                setRepporthtml(body.message.toString())
                                document.getElementById("reportviewer").style.visibility = "visible"
                                document.getElementById("reportviewercontent").innerHTML = body.message
                            })
                        }
                        if (response.status === 200) {
                            setHTMLMessage("Report triggered successfully");
                        }
                    } else {
                        setHTMLMessage("Error triggering report");
                    }
                });
            } else {
                console.error("Connector function not found");
            }
        }
        else {
            let errormessage = "<UL>"
            mandaterrors.map(param => {
                if (param.dependency !== undefined) {

                    const test = mandaterrors.filter(a => a.name === param.dependency)
                    if (test.length > 0) {
                        document.getElementById("mandatparam-" + param.name).className = "report-mandat-missing"
                        errormessage = "<LI>" + param.label + "</LI>" + errormessage
                    }
                    else {
                        document.getElementById("mandatparam-" + param.name).innerText = "";
                        document.getElementById("mandatparam-" + param.name).className = "report-mandat"
                    }
                } else {
                    errormessage = "<LI>" + param.label + "</LI>" + errormessage
                    document.getElementById("mandatparam-" + param.name).className = "report-mandat-missing"
                }
            }
            )
            errormessage = errormessage + "</UL>"
            setHTMLMessage("<div>" + t("reportdatamissing") + " <br/><div class='report_errorlist'>" + errormessage + "</div></div>");
        }
    }
    return (
        <>
            <div id="main">
                <header>
                    <div id="errordiv" className='error'></div>
                    <div id="coverAllmessage" className="coverall">
                        <div id="messagediv" className='message'>
                            <div id="messagetext" className="MessageText">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean at justo eu risus molestie egestas a rhoncus tellus.
                                Mauris laoreet, dolor at molestie facilisis, metus lorem ornare felis, nec porta sem nulla id dolor. </div>
                            <center><Button type="button" id="cancelButton" className="OkCancel" onClick={clearMessage}>{t("OK")}</Button></center>
                        </div>
                    </div>
                </header>
                <div id="return" className="form">
                    <h1 className="title">{t('Rapporten')}</h1>
                    <div className="report-form">
                        <label className='report-label' htmlFor="reportSelect">{t('Report')}</label>
                        <select id="reportSelect" className="report-control" value={selectedReportKey} onChange={handleReportChange}>
                            <option value="">{t('Select report')}</option>
                            {reports.map(report => (
                                <option key={report.key} value={report.key}>{t(report.label)}</option>
                            ))}
                        </select>
                    </div>
                    <div className="report-form">
                        <label className='report-label' htmlFor="reportSelect">requested by</label>
                        <input
                            id='requester'
                            type='text'
                            className="report-control"
                            name='requestedby'
                            value={user.achternaam + ", " + user.voornaam}
                            onChange={e => handleParamChange(e.target.name, e.target.value, null)}
                            disabled={true}
                        />
                    </div>
                    {/* <div className="report-form">
                        <label className='report-label' htmlFor="reportSelect">open in nieuw venster</label>
                        <input
                            id='newwindow'
                            type='checkbox'
                            name='newwindow'
                            className='checkbox'
                        />
                    </div>
                    <br></br> */}
                    <div className="contentbox">
                        <label className='report-title'>Filters {selectedReport !== undefined ? selectedReport.buttonLabel : ""}</label>
                        <br></br>
                        {selectedReport && selectedReport.params.map(param => (
                            setcontrol(param)
                        ))}

                        {selectedReport && (
                            <div className="report-form" >
                                <p></p>
                                <div>
                                    <Button onClick={triggerReportClick} type="button" className="report-button btn btn-primary margin-right" >
                                        {/* {t(selectedReport.buttonLabel || 'Trigger')} */} Get
                                    </Button>
                                    <Button onClick={() => clearreport(selectedReport.key)} type="button" className="report-button btn btn-primary margin-right" >
                                        Clear
                                    </Button>
                                </div>
                            </div>
                        )}
                        <br></br>
                    </div>
                </div>
                <div id='reportviewer' className='report-viewer'>
                    <div id="printtoolbox" className='report-toolbox'>
                        <div id='printbutton' className='report-print' onClick={() => printreport()}><GrPrint /></div>
                        <div id='openwindow' className='report-print' onClick={() => openinwindow()}  ><RxOpenInNewWindow /></div>
                        <div id='savefile' className='report-print' style={employee !== null ? { display: 'block' } : { display: 'none' }} onClick={() => savereport()}><CiSaveUp2 /></div>
                    </div>
                    <div id='reportviewercontent' className='report-content'></div>
                </div>
            </div>
        </>
    )
}

export default TriggersReports;
